<template>
  <div class="general">
    <div class="view-set-password-general general">
      <v-navigation-drawer permanent absolute>
        <v-container fill-height>
          <div class="master-container">
            <div class="form" v-if="!sent">
              <v-form
                @submit.prevent="requestLogin"
                v-model="validForm"
                ref="form"
                class="flex-grow-1 d-flex flex-column align-stretch"
              >
                <header class="mb-9 text-center">
                  <h1 class="disp-1 mb-3">
                    {{ actionTitle }}
                  </h1>
                  <p class="disp-2">
                    {{ actionSubTitle }}
                  </p>
                </header>
                <v-alert v-if="status == 'error'" type="error">
                  {{ message }}
                </v-alert>
                <v-text-field
                  v-model="password"
                  @focus="checkRepeat"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  :label="$t('Mot de passe')"
                  hide-details
                  filled
                  validate-on-blur
                  :rules="[rules.required]"
                  required
                  @click:append="showPassword = !showPassword"
                  class="mb-3"
                  :color="`${appColor.primary}`"
                />
                <v-text-field
                  v-model="passwordRepeat"
                  @focus="checkRepeat"
                  :append-icon="showPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPasswordRepeat ? 'text' : 'password'"
                  :label="$t('Confirmer mon mot de passe')"
                  filled
                  :rules="[rules.required, passwordConfirmationRule]"
                  required
                  @click:append="showPasswordRepeat = !showPasswordRepeat"
                  class=""
                  :color="`${appColor.primary}`"
                />
                <v-btn
                  type="submit"
                  :disabled="!validForm"
                  :loading="loading"
                  :color="`${appColor.primary}`"
                  large
                  rounded
                  class="align-self-center mb-9 px-12 send"
                  >{{ $t("Enregistrer") }}</v-btn
                >
              </v-form>
            </div>
            <div class="apps-container mt-9">
              <header class="mb-9 text-center services-title" v-if="sent">
                <h1 class="disp-1 mb-3">
                  {{ actionTitle }}
                </h1>
              </header>
              <div class="apps">
                <div
                  v-for="app in apps"
                  :key="app.id"
                  class="app mb-12"
                  :class="appClass"
                >
                  <a :href="`${app.url}`">
                    <div class="app-logo-container">
                      <v-img
                        class="align-self-center mb-3 app-logo"
                        :src="`${app.logo}`"
                        :width="50"
                        :height="50"
                        :alt="`${app.nom}`"
                      />
                    </div>
                    <div class="app-name">
                      {{ app.nomCustom }}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </v-navigation-drawer>
      <div class="env" :class="env">
        <div>{{ env }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import configGeneral from "@/config/general.json";
import { createNamespacedHelpers } from "vuex";
import {
  SET_PASSWORD_GENERAL,
  ADD_SNACKBAR,
  CHECK_TOKEN_GENERAL
} from "@/store/action-types";
const { mapActions: mapAuthActions } = createNamespacedHelpers(`auth`);

const { mapActions: mapAppActions } = createNamespacedHelpers(`app`);

export default {
  data() {
    return {
      env: process.env.VUE_APP_API_ENV,
      appClass: "disable-app",
      sent: false,
      appLogo: require("@/assets/logo-app/favicon-oiso.png"),
      appName: "Adequation",
      appColor: { primary: "primary_general", secondary: "secondary_general" },
      apps: null,
      loading: false,
      token: this.$route.query.token || null,
      validForm: false,
      password: "",
      passwordRepeat: "",
      showPassword: false,
      showPasswordRepeat: false,
      status: null,
      message: null,
      actionTitle: "CRÉATION DU NOUVEAU MOT DE PASSE",
      actionSubTitle: "",
      rules: {
        required: value => !!value || this.$t("Requis."),
        equal: value => value == this.password
      }
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.passwordRepeat == "" ||
        this.password === this.passwordRepeat ||
        this.$t("Les mots de passe ne sont pas identiques");
    }
  },
  beforeMount() {
    if (!this.token) {
      this.redirectToLogin();
    }

    //Check token
    this.checkToken({
      token: this.token
    })
      .then(res => {
        //return true;
        //200 : ras
        if (res.status >= 200 && res.status < 300) {
          //do nothing
          //TODO JNA : display logo (inactive)
          this.apps = res.data.content.list;

          this.apps.forEach(item => {
            let app =
              configGeneral[item["id"].toUpperCase()] ||
              configGeneral["default"] ||
              null;
            item["logo"] =
              app == null ? null : require("@/assets/logo-app/" + app.favicon);
            item["nomCustom"] =
              app == null
                ? item["nom"]
                : app.name != null && app.name.length > 0
                ? app.name
                : item["nom"];
          });
          this.apps.sort((a, b) =>
            a.nomCustom.toUpperCase() > b.nomCustom.toUpperCase() ? 1 : -1
          );
          //console.log(this.apps);
        }
        //401 : redirection resetpassword + message d'erreur (message dans le store)
        else if (res.status == 401) {
          this.redirectToResetPassword();
        }
        //!200 & !401 -> "contact administrator"
        else {
          this.message = this.$t(
            "Une erreur a eu lieu. \n Veuillez contacter l'administrateur contact@adequation-france.com."
          );
          this.status = "error";
        }
      })
      .catch(() => {
        this.message = this.$t(
          "Une erreur a eu lieu. \n Veuillez contacter l'administrateur contact@adequation-france.com."
        );
        this.status = "error";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapAuthActions({
      setPassword: SET_PASSWORD_GENERAL,
      checkToken: CHECK_TOKEN_GENERAL
    }),
    ...mapAppActions({
      addSnackbar: ADD_SNACKBAR
    }),
    checkRepeat() {
      this.validForm = this.password === this.passwordRepeat;
    },
    requestLogin() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        this.setPassword({
          password: this.password,
          passwordRepeat: this.passwordRepeat,
          token: this.token
        })
          .then(res => {
            if (res.status >= 200 && res.status < 300) {
              // this.redirectToLogin();
              this.addSnackbar({
                message: this.$t("Mot de passe mis à jour.")
              });

              //add table with app logo
              //set to active app logo!!
              this.actionTitle = "ACCÉDEZ À TOUS VOS SERVICES";
              this.sent = true;
              this.appClass = "";
            } else {
              this.message = this.$t(
                "Une erreur a eu lieu. Veuillez réessayer."
              );
              this.status = "error";
            }
          })
          .catch(() => {
            this.message = this.$t(
              "Une erreur a eu lieu. \n Veuillez contacter l'administrateur contact@adequation-france.com."
            );
            this.status = "error";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    redirectToLogin() {
      this.$router.push({ name: "login" });
    },
    redirectToResetPassword() {
      this.$router.push({
        path: "reset-password",
        query: { token: this.token }
      });
    }
  },
  watch: {
    password(n) {
      this.validForm = n === this.passwordRepeat;
    },
    passwordRepeat(n) {
      this.validForm = n === this.password;
    }
  }
};
</script>

<style lang="scss">
.general {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100;
  height: 100%;
  margin: auto;
  background-color: white;
}

.view-set-password-general {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  //background: url("~@/assets/login-background.jpg") no-repeat center right/cover;
  width: 90%;
  height: 90%;
  margin: auto;
  //background-color: blue;

  .master-container {
    margin: 0 auto;
    width: 100%;
  }

  .services-title {
    margin: 0 auto;
    //width:50%;
    //margin-top:100px;
    //background-color: pink;
  }

  .apps-container {
    width: 100%;
    margin: 0 auto;

    .apps {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      width: 60%;
      //background-color: yellow;
      // align-items: flex-start;
      justify-content: center;
      .disable-app {
        opacity: 0.5;
        pointer-events: none;
        cursor: default;
        text-decoration: none;
        color: black;
      }
      .app {
        width: 25%;
        margin-bottom: 24px;
        //background-color: pink;
        a:link {
          text-decoration: none;
        }
        a:link > .app-name {
          color: black;
          opacity: 0.3;
          text-decoration: none;
        }
        a:visited > .app-name {
          color: black;
          text-decoration: none;
        }
        a:hover > .app-name {
          opacity: 1;
          text-decoration: none;
        }
        a:active > .app-name {
          color: black;
          text-decoration: none;
        }

        .app-name {
          //background-color: blue;
          text-align: center;
          font-size: 12px;
          font-weight: bold;
        }
        .app-logo-container {
          margin: 0 auto !important;
          width: fit-content;

          .app-logo {
            //background-color: rgb(200, 200, 233);
            //margin: 0 8px 0 8px;
            text-align: center;
            .v-image__image {
              background-size: contain;
            }
          }
        }
      }
    }
  }

  .error {
    white-space: pre-line;
  }

  .env {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: rgb(255, 255, 255);
    height: 96px;
    width: 96px;
    border-radius: 50%;

    position: fixed;
    left: 8px;
    //bottom: 8px;
    z-index: 999;
  }

  .LOCAL {
    background-color: #c41c00;
    opacity: 0.8;
  }
  .DEV,
  .RCT {
    background-color: #c41c00;
    opacity: 0.8;
  }
  .PROD {
    background-color: rgb(255, 255, 255);
    visibility: hidden;
  }

  .v-content {
    background-color: white;
  }

  .container {
    display: flex !important;

    .form {
      width: 424px;
      margin: 0 auto;
    }
  }

  .v-navigation-drawer {
    width: 100% !important;
    //margin: 0 auto;
  }

  #v-navigation-drawer-form {
    width: 100% !important;
    //margin: 0 auto;
  }
  .disp-1 {
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: center;
  }
  .disp-2 {
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: center;
  }

  .v-navigation-drawer__border {
    background: none !important;
  }

  .send .v-btn__content {
    color: white;
  }
}
</style>
